var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-wrapper section-space--inner--120"},[_c('div',{staticClass:"service-section"},[_c('div',{staticClass:"container"})])])}]

export { render, staticRenderFns }